module.exports = __webpack_public_path__ + "img/16.2d76b3b5.jpg";